import { render } from "./invoice-details.vue?vue&type=template&id=127cd75f"
import script from "./invoice-details.vue?vue&type=script&lang=js"
export * from "./invoice-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__